// @vue/component
export default {
  computed: {
    oneTimePassRoutesQueryParams() {
      const {
        client_uuid, location_uuid, // eslint-disable-line camelcase
      } = this.$route.query;

      return {
        client_uuid, location_uuid,
      };
    },
    routes() {
      const routeNames = {
        welcome: 'oneTimePassWelcome',
        notFound: 'oneTimePassNotFound',
        assessment: 'oneTimePassAssessment',
        criteriaSummary: 'oneTimePassCriteriaSummary',
        induction: 'oneTimePassInduction',
        reviewApplication: 'oneTimePassReviewApplication',
        success: 'oneTimePassSuccess',
      };
      const routeSpecificConfig = {};
      const keys = Object.keys(routeNames);

      return _.zipObject(keys, keys.map((key) => {
        const commonConfig = {
          name: routeNames[key],
          query: this.oneTimePassRoutesQueryParams,
        };
        return _.merge(commonConfig, (routeSpecificConfig[key] || {}));
      }));
    },
  },
};
